'use strcit';

angular.module('strongPromptForBigScreenModule', [])
    .controller('strongPromptForBigScreenCtrl', ['$scope', '$sessionStorage', '$modalInstance',
        function ($scope, $sessionStorage, $modalInstance) {
            
            initData();

            /**
             * [initData description]
             *
             * @return  {[type]}  [return description]跳转倒区县大屏
             */
            function initData() {   
                $scope.goToBigScreen = function() {
                    var url = window.location.origin + '/xjcountryscreen/#/home?tenantid=' + JSON.parse(sessionStorage.getItem('ls.curUserInfo')).TENANTID;
                    window.open(url);
                    $sessionStorage.set('strongPromtInfo', 'noShow');   
                    $modalInstance.dismiss();     
                };
            }
        }    
    ]);
